import { Reducer } from 'redux';
import {
  ACTION,
  RequestCodes,
  ReceiveCodes,
  RequestBookmarkedCodes,
  ReceiveBookmarkedCodes,
  ChangeViewModeCaseTypes
} from 'app/area/code-selector/action-types';
import { SelectOptions, CodeSelectorState, ViewMode } from 'app/area/code-selector/types';
import { codeItemToStoreValue } from 'app/infrastructure/data/codes';
import { clientCache } from 'app/infrastructure/universal';
import { viewModeCacheKeyCaseTypes } from 'app/area/code-selector/constants';

export const INITIAL_STATE: SelectOptions = {
  fetching: false,
  items: [],
  bookmarkedCodes: {fetching: false, items: []},
  viewModeCaseTypes: clientCache.getItem(viewModeCacheKeyCaseTypes) || ViewMode.allCodes
};

const reducers: {[indexer: string]: Reducer<SelectOptions> } = {
  [ACTION.RequestCodes]: (state: SelectOptions, action: RequestCodes): SelectOptions => {
    return {
      ...state,
      fetching: true,
      items: []
    };
  },

  [ACTION.ReceiveCodes]: (state: SelectOptions, action: ReceiveCodes): CodeSelectorState => {

    return {
      ...state,
      fetching: false,
      items: action.codes.map(codeItemToStoreValue)
    };
  },
  
  [ACTION.RequestBookmarkedCodes]: (state: CodeSelectorState, action: RequestBookmarkedCodes): CodeSelectorState => {

    return {
      ...state,
      items: [],
      bookmarkedCodes: {
        fetching: true,
        items: []
      }
    };
  },

  [ACTION.ReceiveBookmarkedCodes]: (state: CodeSelectorState, action: ReceiveBookmarkedCodes): CodeSelectorState => {

    return {
      ...state,
      bookmarkedCodes: {
        fetching: false,
        items: action.bookmarkedCodes.map(codeItemToStoreValue)
      }
    };
  },

  [ACTION.ChangeViewModeCaseTypes]: (state: CodeSelectorState, action: ChangeViewModeCaseTypes): CodeSelectorState => {
    return {
      ...state,
      viewModeCaseTypes: action.mode
    };
  }
};

export const reducer: Reducer<CodeSelectorState> = (state: CodeSelectorState = INITIAL_STATE, action: any) => {
  const r = reducers[action.type];
  return (r && r(state, action)) || state;
};
